var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.091,
    height: 19.313,
    viewBox: "0 0 28.091 19.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6226",
    "data-name": "Group 6226",
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16978",
    "data-name": "Path 16978",
    d: "M28.091,84.554V83.072A3.072,3.072,0,0,0,25.018,80H3.072A3.072,3.072,0,0,0,0,83.072v1.481a.274.274,0,0,0,.274.274H27.817a.274.274,0,0,0,.274-.273Z",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16979",
    "data-name": "Path 16979",
    d: "M0,200.274v9.382a3.072,3.072,0,0,0,3.072,3.072H25.018a3.072,3.072,0,0,0,3.072-3.072v-9.382a.274.274,0,0,0-.274-.274H.274a.274.274,0,0,0-.274.274Zm7.023,7.187a.878.878,0,0,1-.878.878H5.267a.878.878,0,0,1-.878-.878v-.878a.878.878,0,0,1,.878-.878h.878a.878.878,0,0,1,.878.878Z",
    transform: "translate(0 -113.416)",
    fill: "#bebebe"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/Credit-Card-icon.d7fca0e0e924457d433020aca564a4fa.svg";
export { ForwardRef as ReactComponent };